"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoiDialog = PoiDialog;
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _Phone2 = _interopRequireDefault(require("@mui/icons-material/Phone"));
var _Email2 = _interopRequireDefault(require("@mui/icons-material/Email"));
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _Public2 = _interopRequireDefault(require("@mui/icons-material/Public"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _accueilVelo = _interopRequireDefault(require("../assets/images/poi/accueil-velo.png"));
var _hooks = require("../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PoiDialog(_ref) {
  let {
    categories: _categories,
    poi,
    ...props
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    copy: copyToClipboard
  } = (0, _hooks.useClipboard)(() => enqueueSnackbar(t('commons.phone_copied_to_clipboard')), () => enqueueSnackbar(t('commons.failed_to_copy_phone_to_clipboard')));
  const photo = poi?.photos[0];
  const hasCategory = {};
  let categories = _categories.reduce((res, category) => {
    const {
      code,
      labelKey
    } = category;
    if (poi && labelKey && poi.categoryCodes.indexOf(code) > -1 && !hasCategory[labelKey]) {
      res.push(category);
      hasCategory[labelKey] = true;
    }
    return res;
  }, []);
  const description = poi?.description;
  let title = poi?.title;
  if (!title) {
    const category = categories[0];
    if (category && category.labelKey) {
      title = t(category.labelKey, {
        context: 'one'
      });
      categories = categories.slice(1);
    }
  }
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), photo && /*#__PURE__*/_react.default.createElement(PhotoWrapper, {
    url: photo.thumbnailUrl || ''
  }), /*#__PURE__*/_react.default.createElement(StyledDialogTitle, null, poi?.bicycleHome && /*#__PURE__*/_react.default.createElement(StyledHeaderLogo, {
    title: "Accueil v\xE9lo",
    url: _accueilVelo.default
  }), title, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, categories.map((_ref2, index) => {
    let {
      id,
      labelKey
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: id
    }, index > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0\u2022\xA0"), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: labelKey,
      values: {
        context: 'one'
      }
    }));
  }))), /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), categories.length > 0 && /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    component: "p",
    variant: "caption"
  }, description)), poi && (poi.website || poi.email || poi.phone) && /*#__PURE__*/_react.default.createElement(StyledDialogActions, null, poi.website && /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: "primary",
    component: "a",
    href: poi.website,
    rel: "noreferrer",
    size: "small",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Public2.default, null), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.website"
  })), poi.email && /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: "primary",
    component: "a",
    href: `mailto:${poi.email}`,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Email2.default, null), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.email"
  })), poi.phone && /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: "primary",
    onClick: () => copyToClipboard(poi.phone || ''),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Phone2.default, null), poi.phone)));
}
const PhotoWrapper = _styledComponents.default.div`
  background-color: whitesmoke;
  background-image: ${_ref3 => {
  let {
    url
  } = _ref3;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 50%;
`;
const StyledDialogTitle = (0, _styledComponents.default)(_DialogTitle2.default)`
  && {
    padding-right: 46px;

    h2 {
      align-items: center;
      display: flex;
    }
  }
`;
const StyledHeaderLogo = _styledComponents.default.div`
  align-self: center;
  background-image: ${_ref4 => {
  let {
    url
  } = _ref4;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  margin-right: 8px;
  width: 48px;
`;
const CloseButtonWrapper = _styledComponents.default.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }
  }
`;
const StyledDialogActions = (0, _styledComponents.default)(_DialogActions2.default)`
  svg {
    margin-right: 4px;
  }
`;